import React, {memo} from "react";
import {attachmentKeyGenerator, formikPropertyChanged} from "./index";
import {useTranslation} from "react-i18next";
import FormSection from "../../../components/FormSection";
import useDialog from "../../../components/useDialog";
import AttachmentDialog from "./AttachmentDialog";
import Icon from "@mui/material/Icon";
import Attachment from "./Attachment";
import MDTypography from "materialDashboard/components/MDTypography";
import MDButton from "materialDashboard/components/MDButton";

const attributes = ['attachments']

const Attachments = memo(({formik, incidentRegistry, inputDisabled}) => {
    const {t} = useTranslation(['incidents']);
    const newAttachmentDialog = useDialog();
    const editAttachmentDialog = useDialog();
    const [attachment, setAttachment] = React.useState({});

    const handleCreate = (attachment) => {
        const attachments = formik.values?.attachments ?? [];
        formik.setFieldValue('attachments', [...attachments, {...attachment, key: attachmentKeyGenerator()}]);
        newAttachmentDialog.close();
    }

    const handleUpdate = (attachment) => {
        const attachments = formik.values?.attachments ?? [];
        formik.setFieldValue('attachments', attachments.map((a => a.key === attachment.key ? attachment : a)));
        editAttachmentDialog.close();
    }

    const handleDelete = (attachment) => {
        const attachments = formik.values?.attachments ?? [];
        formik.setFieldValue('attachments', attachments.filter(a => a.key !== attachment.key));
    }

    const handleEdit = (attachment) => {
        setAttachment(attachment);
        editAttachmentDialog.open();
    }

    return <FormSection title={t('incidentForm.attachmentsTitle')}
                        unStyledCollapse>
        {
            !inputDisabled && <MDButton onClick={newAttachmentDialog.open} variant="outlined" color="info"
                                       sx={{width: 'fit-content', ml: 'auto', alignSelf: "end"}}>
                {t('incidentForm.attachments.addAttachment')}
            </MDButton>
        }

        <AttachmentDialog isOpen={newAttachmentDialog.isOpen}
                          onClose={newAttachmentDialog.close}
                          onApply={handleCreate}
                          incidentRegistry={incidentRegistry}/>

        <AttachmentDialog isOpen={editAttachmentDialog.isOpen}
                          onClose={editAttachmentDialog.close}
                          onApply={handleUpdate}
                          attachment={attachment}
                          incidentRegistry={incidentRegistry}/>

        {
            formik.values.attachments?.length > 0 ?
                formik.values.attachments.map((attachment, index) => {
                    return <Attachment key={attachment.key}
                                       attachment={attachment}
                                       number={index + 1}
                                       incidentRegistry={incidentRegistry}
                                       onDelete={handleDelete}
                                       onEdit={() => handleEdit(attachment)}
                                       inputDisabled={inputDisabled}/>
                }) :
                <MDTypography variant="body2" color="secondary" textAlign='center'>
                    <Icon fontSize="large">inbox</Icon><br/>
                    {t('incidentForm.attachments.noAttachment')}
                </MDTypography>
        }
    </FormSection>

}, (prevProps, nextProps) => formikPropertyChanged(prevProps, nextProps, attributes))


export default Attachments;